import React from "react";
import { ReactComponent as LoadingIcon } from "../../assets/icons/loading.svg";
import { useTranslation } from "react-i18next";

const Loading = () => {
  const { t } = useTranslation(["common"]);

  return (
    <div className="w-100 d-flex align-items-center justify-content-center fs-5" style={{ height: "100vh" }}>
      <LoadingIcon className="me-3" /> {t("Loading")}...
    </div>
  );
};

export default Loading;
